var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-inline-block" },
    [
      _c(
        "b-skeleton-wrapper",
        {
          attrs: { loading: _vm.isLoadInProgress },
          scopedSlots: _vm._u([
            {
              key: "loading",
              fn: function() {
                return [
                  _c("div", { staticClass: "product-box" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "item-image-holder d-flex justify-content-center align-items-center"
                      },
                      [
                        _c("b-skeleton-img", {
                          staticClass: "w-100 h-100",
                          attrs: { "no-aspect": "", animation: "fade" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between w-100 p-lg-2"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "item w-100" },
                          [
                            _c("b-skeleton", { staticClass: "w-50" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "item-name" },
                              [_c("b-skeleton", { staticClass: "w-100 mt-3" })],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-skeleton", { staticClass: "w-25" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center mt-2"
                              },
                              [
                                _c("b-skeleton", { staticClass: "w-25" }),
                                _vm._v(" "),
                                _c("b-skeleton", { staticClass: "w-25" })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "product-box d-flex flex-column justify-content-between h-100"
            },
            [
              _vm.productToShow !== null
                ? _c(
                    "div",
                    {
                      staticClass:
                        "product-box d-flex flex-column justify-content-between h-100"
                    },
                    [
                      _c("div", { staticClass: "d-flex flex-column" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "item-image-holder d-flex justify-content-center align-items-center"
                          },
                          [
                            _vm.productToShow.anchorTarget === "_blank"
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.productToShow.url,
                                      title:
                                        _vm.productNameWithBrandAndPackaging,
                                      target: _vm.productToShow.anchorTarget,
                                      itemprop: "image",
                                      itemscope: "",
                                      itemtype: "https://schema.org/ImageObject"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.sendDataLayerItemSelected(
                                          _vm.productToShow
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("b-img-lazy", {
                                      attrs: {
                                        src: _vm.productToShow.imageSrc,
                                        alt:
                                          _vm.productNameWithBrandAndPackaging,
                                        itemprop: "url"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "url",
                                        content: _vm.productToShow.imageSrc
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "width",
                                        content: "600"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "height",
                                        content: "600"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: _vm.productToShow.url,
                                      title:
                                        _vm.productNameWithBrandAndPackaging,
                                      target: _vm.productToShow.anchorTarget,
                                      itemprop: "image",
                                      itemscope: "",
                                      itemtype: "https://schema.org/ImageObject"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.sendDataLayerItemSelected(
                                          _vm.productToShow
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("b-img-lazy", {
                                      attrs: {
                                        src: _vm.productToShow.imageSrc,
                                        alt:
                                          _vm.productNameWithBrandAndPackaging,
                                        itemprop: "url"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "url",
                                        content: _vm.productToShow.imageSrc
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "width",
                                        content: "600"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "height",
                                        content: "600"
                                      }
                                    })
                                  ],
                                  1
                                )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between w-100 p-lg-2"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "item w-100" },
                              [
                                _vm.productToShow.anchorTarget === "_blank"
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.productToShow.brandUrl,
                                          target: _vm.productToShow.anchorTarget
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.sendDataLayerItemSelected(
                                              _vm.productToShow
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "brand-name my-2",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.productToShow.brandName
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  : _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: _vm.productToShow.brandUrl,
                                          target: _vm.productToShow.anchorTarget
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.sendDataLayerItemSelected(
                                              _vm.productToShow
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "brand-name my-2",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.productToShow.brandName
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                _vm._v(" "),
                                _vm.productToShow.anchorTarget === "_blank"
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.productToShow.url,
                                          title:
                                            _vm.productToShow
                                              .productNameWithBrandAndPackaging,
                                          target: _vm.productToShow.anchorTarget
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.sendDataLayerItemSelected(
                                              _vm.productToShow
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item-name" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.productToShow.name) +
                                                "\n                  "
                                            ),
                                            _vm.productToShow.packaging !== ""
                                              ? [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm.productToShow
                                                          .packaging
                                                      ) +
                                                      ")"
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  : _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: _vm.productToShow.url,
                                          title:
                                            _vm.productToShow
                                              .productNameWithBrandAndPackaging,
                                          target: _vm.productToShow.anchorTarget
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.sendDataLayerItemSelected(
                                              _vm.productToShow
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item-name" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.productToShow.name) +
                                                "\n                  "
                                            ),
                                            _vm.productToShow.packaging !== ""
                                              ? [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm.productToShow
                                                          .packaging
                                                      ) +
                                                      ")"
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ]
                                    )
                              ],
                              1
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between w-100 p-lg-2"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "item w-100" },
                            [
                              _vm.productToShow.anchorTarget === "_blank"
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.productToShow.url,
                                        title:
                                          _vm.productToShow
                                            .productNameWithBrandAndPackaging,
                                        target: _vm.productToShow.anchorTarget
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.sendDataLayerItemSelected(
                                            _vm.productToShow
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("rating-stars", {
                                        staticClass: "mt-2",
                                        attrs: {
                                          rating: _vm.productToShow.rating,
                                          "review-count":
                                            _vm.productToShow.reviewCount,
                                          "is-review-count-visible": false
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: _vm.productToShow.url,
                                        title:
                                          _vm.productToShow
                                            .productNameWithBrandAndPackaging,
                                        target: _vm.productToShow.anchorTarget
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.sendDataLayerItemSelected(
                                            _vm.productToShow
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("rating-stars", {
                                        staticClass: "mt-2",
                                        attrs: {
                                          rating: _vm.productToShow.rating,
                                          "review-count":
                                            _vm.productToShow.reviewCount,
                                          "is-review-count-visible": false
                                        }
                                      })
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "badge-container d-flex flex-wrap"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "badge-block d-flex flex-wrap"
                                    },
                                    [
                                      _vm.productToShow.isDiscounted
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "badge badge-discount"
                                            },
                                            [
                                              _vm._v(
                                                "\n                  -" +
                                                  _vm._s(
                                                    _vm.productToShow
                                                      .discountPercent
                                                  ) +
                                                  "%\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "badge-block d-flex flex-wrap"
                                    },
                                    [
                                      _vm.productToShow.isNewItem
                                        ? _c("div", {
                                            directives: [
                                              {
                                                name: "t",
                                                rawName: "v-t",
                                                value: "NEW_PRODUCT_FLAG",
                                                expression: "'NEW_PRODUCT_FLAG'"
                                              }
                                            ],
                                            staticClass: "badge badge-newitem"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "price old" }, [
                                _vm.productToShow.isDiscounted
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.productToShow
                                              .originalPriceFormatted
                                          ) +
                                          "\n                "
                                      ),
                                      _vm.productToShow
                                        .originalPriceSecondaryFormatted !==
                                      null
                                        ? _c("span", { staticClass: "ml-1" }, [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.productToShow
                                                    .originalPriceSecondaryFormatted
                                                ) +
                                                ")\n                "
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center"
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "price",
                                        class: {
                                          discounted:
                                            _vm.productToShow.isDiscounted
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.productToShow.priceFormatted
                                            ) +
                                            "\n                  "
                                        ),
                                        _vm.productToShow
                                          .priceSecondaryFormatted !== null
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                    (" +
                                                  _vm._s(
                                                    _vm.productToShow
                                                      .priceSecondaryFormatted
                                                  ) +
                                                  ")\n                  "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "unit-price" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.productToShow.unitPriceFormatted
                                          ) +
                                          "\n                  "
                                      ),
                                      _vm.productToShow
                                        .unitPriceSecondaryFormatted !== null
                                        ? _c("div", [
                                            _vm._v(
                                              "\n                    (" +
                                                _vm._s(
                                                  _vm.productToShow
                                                    .unitPriceSecondaryFormatted
                                                ) +
                                                ")\n                  "
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  !_vm.isCatalogPage &&
                                  _vm.productToShow.showAddToCartBtn
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "custom-button filled add-to-cart d-block d-lg-flex align-items-end justify-content-center mb-3",
                                          class: {
                                            "show-icon": _vm.cartButtonOnlyIcon
                                          },
                                          attrs: {
                                            disabled:
                                              !_vm.productToShow.orderable ||
                                              _vm.isProductAddToCartInProgress,
                                            "aria-label": _vm.$t(
                                              "term_megrendelem"
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.addToCart(
                                                _vm.productToShow
                                              )
                                            }
                                          }
                                        },
                                        [
                                          !_vm.cartButtonOnlyIcon
                                            ? _c("span", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "term_megrendelem",
                                                    expression:
                                                      "'term_megrendelem'"
                                                  }
                                                ],
                                                staticClass: "d-none d-xl-block"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.currentProductIdForAddToCartModal !== null
                        ? _c("add-to-cart-modal", {
                            attrs: {
                              "product-id":
                                _vm.currentProductIdForAddToCartModal
                            },
                            on: {
                              close: function($event) {
                                _vm.currentProductIdForAddToCartModal = null
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }